import PropTypes from 'prop-types'
import React from 'react'

import {
    Wrapper,
    Title,
    Body,
    Cta,
    Image,
    Content,
    ImageWrapper,
} from './styles'

const Slide = props => {
    const { title, body, cta, img, bgColor } = props

    return (
        <Wrapper bgColor={bgColor}>
            <Content>
                <Title>{title}</Title>
                <Body>{body}</Body>
                <Cta href={cta.link} target="_blank">
                    {cta.text}
                </Cta>
            </Content>
            <ImageWrapper>
                <Image src={img.src} alt={img.alt} />
            </ImageWrapper>
        </Wrapper>
    )
}

Slide.propTypes = {
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    cta: PropTypes.exact({
        text: PropTypes.string,
        link: PropTypes.string,
    }),
    img: PropTypes.exact({
        src: PropTypes.string,
        alt: PropTypes.string,
    }),
    bgColor: PropTypes.string,
}

Slide.defaultProps = {
    title: 'Title',
    body: 'Boooooooody',
    cta: {
        text: 'cta text',
        link: '#',
    },
    img: {
        src: ``,
        alt: '',
    },
    bgColor: '#FDFAF6',
}

export default Slide
